import React,{Component} from 'react';

import $ from 'jquery';

import config from '../../../../config';
import API_Config from '../../../../API_Config';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';


class ContentRightCustomeReport extends Component {

    render() {
        const  isLoading  = config.data.price.single == undefined ? true : false;
        return(
            <div>

                    <div class="looking">
                        <p>Looking to Customize Report? </p>
                    </div>
                    <div> <span id="chkemailcustom"></span>
                        <input type="hidden" name="rep_title" id="rep_title" value="Global Biologics Market - Segmented by Product, and Applications - Growth, Trends and Forecasts (2018 - 2023)" />
                            <input type="hidden" name="urls" id="urls" value="https://mordorintelligence.com:81/industry-reports/biologics-market" />
                                <input type="hidden" name="cat_title" id="cat_title" value="Healthcare" />
                                    <input type="hidden" name="sub_cat_id" id="sub_cat_id" value="2735" />
                                        <input type="hidden" name="sub_cat_name" id="sub_cat_name" value="Biotechnology" />
                                            <input type="hidden" name="cat_id" id="cat_id" value="61" />
                                                <input type="hidden" name="rep_id" id="rep_id" value="35304" />
                                                    <input type="hidden" name="ip_address" id="ip_address" value="111.93.31.18" />
                                                        <input type="hidden" name="customsource_url" id="customsource_url" value="https://mordorintelligence.com:81/industry-reports/" />
                                                            <input type="hidden" name="custom_user_session_id" id="custom_user_session_id" value="0a42a5008848e0d6fa24c5ccb36acc07" />
                                                                <input type="email" name="custom_email" id="custom_email" class="fullwd" placeholder="Your Email" validate={this.validateEmail} required="" /> </div>
                    <div>

                        <textarea class="fullwd" name="custom_area" id="custom_area" placeholder="I am looking specifically for . . ." required=""></textarea>
                    </div>
                    <div>
                        <button class="sign_letter1" type="button" disabled={isLoading} onClick={this.handleSubmit}>Request for custom Report</button>
                    </div>

                <NotificationContainer />

            </div>
        )
    }
    validateEmail (value) {
        // regex from http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(value);
    }
    handleSubmit() {

           var email = $("#custom_email").val();
           var txtarea = $("#custom_area").val();
           if(email ==''){

               NotificationManager.error('Error', 'Please enter email id !', 5000);
               return false;
           }
           else if(txtarea ==''){
               NotificationManager.error('Error', 'Please enter what you are looking for!', 5000);
               return false;
           }
           else if(email!='' && txtarea !=''){

               var atpos = email.indexOf("@");
               var dotpos = email.lastIndexOf(".");
               if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length) {

                   NotificationManager.error('Error', 'Enter valid email id!', 5000);
                   return false;
               }
               else{
                   //alert("submitted");
                  var postData =
                            {
                               custom_email : email,
                               custom_area  :  txtarea,
                               rep_id :config.data.id,
                               rep_title :config.data.title,
                               cat_id :config.data.category_id,
                               sub_cat_id :config.data.sub_category_id,
                               cat_title :config.data.category,
                               sub_cat_name :config.data.sub_category,
                               urls :"",
                               customsource_url :"",
                               custom_user_session_id :""
                            }

                   $.ajax({
                       type: 'POST',
                       url: API_Config.http_url + API_Config.end_point.custome_report,
                       data: postData
                   })
                       .done(function(data) {
                           NotificationManager.success('Success', 'Customization request accepted successfully', 5000);
                           $("#custom_email").val('');
                           $("#custom_area").val('');
                       })
                       .fail(function(jqXhr) {
                           NotificationManager.error('Error', 'Something went wrong!', 5000);
                       });


               }
           } else {

           }

   }
    componentDidMount() {
        $('form.custom_form').submit(function() {

            var email = $("#custom_email").val();
            var txtarea = $("#custom_area").val();
            if(email ==''){
                alert("Please enter email id");
                return false;
            }
            else if(txtarea ==''){
                alert("Please enter what you are looking for!");
                return false;
            }
            else if(email!=''){

                var atpos = email.indexOf("@");
                var dotpos = email.lastIndexOf(".");
                if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= email.length) {
                    alert("Enter valid email id");
                    return false;
                }
                else{
                    //alert("submitted");
                    var formInput = $(this).serialize();
                    console.log(formInput);
                    $.post("https://mordorintelligence.com:81/customizereportsnodejscall.php",formInput, function(data)
                    {
                        console.log("nodejs customize reports call runns");
                        console.log(data);
                       // __insp.push(['tagSession', {leadid: data}]);
                    });
                    $.post("https://mordorintelligence.com:81/custom_form_db.php",formInput, function(data){
                        $('form.custom_form').trigger("reset");
                        $("#custom_email").val('');
                        $("#custom_area").val('');

                        //$('#myModalRes').modal('show');

                        //alert(data);
                    });
                    return false;
                }
            }
        });
    }

}

export default ContentRightCustomeReport;


// WEBPACK FOOTER //
// ./src/report-description/content/content-right/content-right-custome-report/content-right-custome-report.js